import { Injectable } from '@angular/core'
import { Events, Platform } from 'ionic-angular'
import io from 'socket.io-client'


import { SignalingMessage, SignalingMessageType } from '../../models/models'
import { ConfigProvider } from '../config/config'
import { AbstractSignalingProvider } from './abstract'
import { UserProvider } from '../user/user'
//npm install socket.io-client
//https://socket.io/docs/v2/client-initialization/

@Injectable()
export class SignalingSocketIoProvider extends AbstractSignalingProvider {
	protected static isInitialized: boolean = false;

	private _socket = null

	get socket(): any {
		return this._socket
	}
	set socket(socket) {
		console.debug('[socket_io.set socket]', socket)
		this._socket = socket
	}
	/**
	E'registrato al server di signaling?
	*/
	public get is_initialized(): boolean {
		return !!this._socket
	}
	public get is_connected(): boolean {
		return !!this._socket && this._socket.connected
	}

	constructor(
		protected events: Events,
		protected platform: Platform,
		public users: UserProvider
		//private _network: Network
	) {
		super(events, platform)
		console.debug('[socket_io.new()] Nuovo provider di signaling')
	}
	/*
		TODO
	*/
	protected init_channel(): Promise<boolean> {
		console.debug('[socket_io.init_channel()] Inizializzazione socket..')
		if(this.is_initialized) {
			console.warn('[socket_io.init_channel()] Socket già inizializzato')
			return Promise.resolve(true)
		}

		/*
		DEFAULT OPTIONS
		const socket = io({
			path: '/socket.io',
			reconnection: true,
			reconnectionAttempts: Infinity,
			reconnectionDelay: 1000,
			reconnectionDelayMax: 5000,
			randomizationFactor: 0.5,
			timeout: 20000,
			autoConnect: true,
			query: {},
			// options of the Engine.IO client
			upgrade: true,
			forceJSONP: false,
			jsonp: true,
			forceBase64: false,
			enablesXDR: false,
			timestampRequests: true,
			timestampParam: 't',
			policyPort: 843,
			transports: ['polling', 'websocket'],
			transportOptions: {},
			rememberUpgrade: false,
			onlyBinaryUpgrades: false,
			requestTimeout: 0,
			protocols: [],
			// options for Node.js
			agent: false,
			pfx: null,
			key: null,
			passphrase: null,
			cert: null,
			ca: null,
			ciphers: [],
			rejectUnauthorized: true,
			perMessageDeflate: true,
			forceNode: false,
			localAddress: null,
			// options for Node.js / React Native
			extraHeaders: {},
		});
		*/



		this.socket = io(ConfigProvider.SIGNALING_SOCKETIO.url, ConfigProvider.SIGNALING_SOCKETIO.config)
		let socket = this.socket
		/*
		EVENTI DI SISTEMA
		*/
		socket.on('connect', () => {
			console.debug('[socket_io.socket.on(connect)] Connessione pronta', { socket: this.socket })
			this.isOnline = true
		})
		socket.on('connect_error', error => {
			console.debug('[socket_io.socket.on(connect_error)] Errore durante la connessione', { socket: this.socket, error })
			this.isOnline = false
		})
		socket.on('connect_timeout', _ => {
			console.debug('[socket_io.socket.on(connect_timeout)] Timeout di connessione', { socket: this.socket })
			this.isOnline = false
		})
		socket.on('connection', _ => {
			console.debug('[socket_io.socket.on(connection)] Connesso', { socket: this.socket })
			this.isOnline = true
		})
		socket.on('disconnect', reason => {
			console.debug('[socket_io.socket.on(disconnect)] Connessione interrotta, causa: ' + reason, { socket: this.socket })
			this.isOnline = false
		})

		socket.on('reconnect', n => {
			console.debug('[socket_io.socket.on(reconnect)] Riconnessione avvenuta al tentativo N° ' + n, { socket: this.socket })
			this.isOnline = true
		})
		socket.on('reconnecting', n => {
			console.debug('[socket_io.socket.on(reconnecting)] Tentativo di riconnessione N° ' + n, { socket: this.socket })
		})
		socket.on('reconnect_attempt', n => {
			console.debug('[socket_io.socket.on(reconnect_attempt)] Tentativo di riconnessione N° ' + n, { socket: this.socket })
		})
		socket.on('reconnect_error', error => {
			console.debug('[socket_io.socket.on(reconnect_error)] Errore di riconnessione', { socket: this.socket, error })
			this.isOnline = false
		})
		socket.on('reconnect_failed', _ => {
			console.debug('[socket_io.socket.on(reconnect_failed)] Riconnessione fallita', { socket: this.socket })
			this.isOnline = false
		})

		socket.on('error', error => {
			console.debug('[socket_io.socket.on(error)] Errore sul socket', { socket: this.socket, error })
		})

		socket.on('ping', _ => {
			console.debug('[socket_io.socket.on(ping)] Inviato Ping?', { socket: this.socket })
		})
		socket.on('pong', ms => {
			console.debug('[socket_io.socket.on(pong)] Ricevuto Pong! in ' + ms + 'ms', { socket: this.socket })
		})
		/**
		MESSAGGI DOMINIO APPLICATIVO
		*/
		socket.on('message', message => {
			console.debug('[socket_io.socket.on(message)] Ricevuto Messaggio generico', { message })
		})
		socket.on('signaling', message => {
			let signaling_message = JSON.parse(message)
			signaling_message.receivedAt = new Date()
			console.debug('[socket_io.socket.on(message)] Ricevuto Messaggio di signaling', { signaling_message })
			this.on_signaling_received(signaling_message)
		})

		console.debug('[socket_io.connect()] Socket inizializzato', this.socket)

		return Promise.resolve(true)
	}

	/**
	 * TODO
	Si connette ed inizia a monitorare lo stato di connessione
	*/
	protected connect(): Promise<void> {
		console.group('[socket_io.connect()] Connessione socket..')

		if(!this.is_initialized) {
			console.info('[socket_io.connect()] Connessione a socket non inizializzato, inizializzo..')
			this.init_channel()
		}

		return new Promise((resolve, reject) => {
			this.socket.connect(() => {
				console.debug('[socket_io.socket.open()] Esito connessione al socket: ' + this.socket.connected)
				if(this.socket.connected) {
					resolve()
				} else {
					reject()
				}
				console.groupEnd()
			})
		})
	}


	/**
	Disconnette il socket
	*/
	protected disconnect() {
		console.debug('[socket_io.disconnect()] Disconnessione dal socket..')

		this.socket.disconnect()
	}

	protected listen() {
		this.send({
			type: SignalingMessageType.LISTEN
		})
		/* /**
		Notifiche messaggi non letti
		* /
		this.nodeMessage = this.database.ref(this.messagePath)
		console.debug('Ascolto notifiche messaggi da leggere per il peer ' + this.peerId + ' sul nodo: ' + this.nodeMessage)


		//this.nodeMessageVisible.on('child_changed', onVisibleUpdated)
		this.nodeMessage.on('child_added', node => this.on_message_visible(node.val()))

		/*
		Ricezione nuovi messaggi di signaling
		* /
		//nodo dei messaggi di signaling in arrivo
		this.nodeSignaling = this.database.ref(this.signalingPath)

		//svuota eventuali messaggi precedenti
		console.debug('Elimino eventuali messaggi di signaling precedenti..')
		this.nodeSignaling.set(null)

		/*
		Ricezione nuovi messaggi di signaling
		* /
		//nodo dei messaggi di signaling in arrivo
		this.nodeSignaling = this.database.ref(this.signalingPath)

		//svuota eventuali messaggi precedenti
		console.debug('Elimino eventuali messaggi di signaling precedenti..')
		this.nodeSignaling.set(null)


		console.debug('Ascolto nuovi messaggi di signaling per il peer ' + this.peerId + ' sul nodo: ' + this.nodeSignaling)
		this.nodeSignaling.on('child_added', (node) => {
			let message = <SignalingMessage>JSON.parse(node.val())
			//Cancella il messaggio subito dopo la ricezione
			node.ref.remove()

			this.on_signaling_received(message)
		}) */
	}

	/**
	Esegue il logout dal server, ma tiene la socket aperta
	*/
	protected delisten() {
		console.group('[socket_io.delisten()] Deregistrazione dal server di signaling')

		this.send({
			type: SignalingMessageType.DELISTEN
		})

		console.groupEnd()
	}


	/**
	*/
	protected send_channel(message: SignalingMessage): Promise<SignalingMessage> {
		console.debug('[socket_io.send()] Invio messaggio di signaling: type=' + message.type + '; receiverId="' + message.receiverId + '"', message)

		if(message.type == 'ping') {
			this.sendPing(message.receiverId)
			return
		}

		if(!this.is_connected) {
			console.warn('[socket_io.send_channel] Tentato invio di messaggio con socket disconnesso')
			return this.connect().then(() => {
				//invia come 'message'
				this.socket.emit('signaling', JSON.stringify(message), forwarded => {
					console.debug('[socket_io.send()] Messaggio passato al server, inoltro: ' + forwarded, { message, forwarded })
				})
				return Promise.resolve(message)
			})
		}

		//invia come 'message'
		this.socket.emit('signaling', JSON.stringify(message), forwarded => {
			console.debug('[socket_io.send()] Messaggio passato al server, inoltro: ' + forwarded, { message, forwarded })
		})
		return Promise.resolve(message)
	}

	/**
Invia PING per verificare se l'altro peer è connesso
In questa implementazione usa la notifica nativa come ping
*/
	public sendPing(receiverId: string): Promise<SignalingMessage> {
		console.debug("[SocketIoSignalingProvider.sendPing(otherId, payload)] Invio PING come notifica a: " + receiverId)



		if(!receiverId) {
			return Promise.reject('Destinatario nullo: Impossibile inviare')
		}


		/**
		 * Siccome il ping è inviato via notifica, registra esplicitamente il proprio id sul signaling
		*/
		this.listen()

		let senderId = this.peerId

		let message = {
			senderId,
			receiverId,
			type: SignalingMessageType.PING,
			sentAt : new Date()
		}

		return new Promise((resolve, reject) => {
			this.users.notify(receiverId, message).then(message => resolve(message)).catch(e => reject(e))
		})
	}
}


// WEBPACK FOOTER //
// ./src/providers/signaling/socket_io.ts